import { put, call, all, fork, takeEvery } from "redux-saga/effects";
import * as PaymentSummaryActions from "../actionTypes/paymentSummaryActionTypes";
import * as PaymentActionCreators from "../actionCreators/paymentSummaryActionCreators"
import { getAccountBalance, getPaymentSummaryDetails } from "../services/APIservice";
import { getTransactionIdFromURL, getValueFromLocalStorage, replaceValueFromLocalStorage } from "../../constants/utils";
import { ARGO_SUCCESS, AUTH_KEY, NOT_AUTHORIZED_ERROR } from "../../constants/constants";


function* onGetAccountBalance() {
  try {
    let txnId = getTransactionIdFromURL();
    yield put(PaymentActionCreators.getAccountBalanceRequest())
    let authKey = getValueFromLocalStorage(AUTH_KEY(txnId))
    if (authKey === null) {
      throw NOT_AUTHORIZED_ERROR
    }
    const { data, headers } = yield call(getAccountBalance);
    const { authorization } = headers;
    if (authorization !== null || authorization !== undefined) {
      replaceValueFromLocalStorage(AUTH_KEY(txnId), authorization)
    }
    if (data.code === ARGO_SUCCESS) {
      yield put(PaymentActionCreators.getAccountBalanceSuccess(data.data));
    } else {
      throw data
    }
  } catch (error) {
    if (error?.response?.data.status === NOT_AUTHORIZED_ERROR.code) {
      yield put(PaymentActionCreators.getAccountBalanceFailure(NOT_AUTHORIZED_ERROR))
    } else {
      yield put(PaymentActionCreators.getAccountBalanceFailure(error))
    }
  }
}


function* onGetPaymentSummary() {
  try {
    let txnId = getTransactionIdFromURL();
    yield put(PaymentActionCreators.getPaymentSummaryRequest())
    let authKey = getValueFromLocalStorage(AUTH_KEY(txnId))
    if (authKey === null) {
      throw NOT_AUTHORIZED_ERROR
    }
    const { data, headers } = yield call(getPaymentSummaryDetails);
    const { authorization } = headers;
    if (authorization !== null || authorization !== undefined) {
      replaceValueFromLocalStorage(AUTH_KEY(txnId), authorization)
    }
    if (data.code === ARGO_SUCCESS) {
      yield put(PaymentActionCreators.getPaymentSummarySuccess(data.data));
    } else {
      throw data
    }
  } catch (error) {
    if (error?.response?.data.status === NOT_AUTHORIZED_ERROR.code) {
      yield put(PaymentActionCreators.getPaymentSummaryFailure(NOT_AUTHORIZED_ERROR))
    } else {
      yield put(PaymentActionCreators.getPaymentSummaryFailure(error))
    }
  }
}

function* watchOnGetAccountBalance() {
  yield takeEvery(PaymentSummaryActions.GET_ACCOUNT_BALANCE, onGetAccountBalance)
}

function* watchOnGetPaymentSummary() {
  yield takeEvery(PaymentSummaryActions.GET_PAYMENT_DETAILS, onGetPaymentSummary)
}

export default function* PaymentSaga() {
  yield all([
    fork(watchOnGetAccountBalance),
    fork(watchOnGetPaymentSummary),
  ])
}